import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import './sanctionOrderModal.css';

const AddSchemePreview = ({ showPreview, setShowPreview, formData, handleSubmit,schemeTypes,financialYears,schemeFlag}) => {
    const handleClose = () => setShowPreview(false);
    return (
        <div>
            <Modal
                size="lg"
                show={showPreview} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Scheme Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body className='previewModalBody'>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Dept. Name</th>
                                <th>Scheme Name</th>
                                <th>Scheme Code.</th>
                                <th>Scheme Type</th>
                                <th>Grant Code</th>
                                <th>Financial Year</th>
                                {/* <th>Carry Forward</th> */}
                                <th>Total Scheme Budget</th>
                                <th>Scheme Doc Uploaded</th>
                                {formData.monitoring_level!="" && <th>Monitor/Control Level</th>}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{formData.department}</td>
                                <td>{formData.name}</td>
                                <td>{formData.code}</td>
                                <td>
                                    {schemeTypes.find(scheme => scheme.id === formData.type)?.title || ""}
                                </td>
                                <td>{formData.grant_code}</td>
                                <td>
                                    {financialYears.find(year => year.id === formData.financial_year)?.year || ""}
                                </td>
                                {/* <td>{formData.carry_forwarded == 1 ? "Yes" : "No"}</td> */}
                                <td>{formData.department}</td>
                                <td>{formData.attachment && formData.attachment.length ? "Yes" : "No"}</td>
                                {formData.monitoring_level!="" && <td>
                                    <select
                                        className="form-control"
                                        name='monitoring_level'
                                        value={formData.monitoring_level} disabled={true}>
                                        <option value="">---Select---</option>
                                        {schemeFlag.map(e => (
                                            <option key={e.id} value={e.id}>{e.name}</option>
                                        ))}
                                    </select>
                                </td>}
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}>
                        Change
                    </Button>
                    <Button variant="primary" onClick={handleSubmit}>
                        SUBMIT
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default AddSchemePreview